<template>
  <div>
    <v-container class="py-0 px-0" id="hide">
      <v-card tile>
        <v-card-text class="p-1">
          <v-row>
            <v-col cols="12" md="2" sm="6">
              <v-text-field
                label="No Transaksi Biaya Truk"
                dense
                small-chips
                hide-details
                disabled
                v-model="formData.nomor_nota"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6">
              <v-text-field
                label="Tanggal"
                type="date"
                dense
                small-chips
                hide-details
                v-model="formData.tgl_nota"
                @change="updateInvoice"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6">
              <v-text-field
                label="No Surat Jalan"
                type="text"
                dense
                small-chips
                hide-details
                v-model="formData.no_surat_jalan"
                @change="updateInvoice"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6">
              <v-text-field
                label="Nomor Polisi"
                type="text"
                dense
                small-chips
                hide-details
                v-model="formData.nomor_polisi"
                @change="updateInvoice"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6">
              <v-text-field
                label="Nama Supir"
                type="text"
                dense
                small-chips
                hide-details
                v-model="formData.nama_supir"
                @change="updateInvoice"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="6">
              <v-autocomplete
                v-model="formData.pembuat_surat"
                :items="items.employees"
                label="Pembuat Surat Jalan"
                dense
                hide-details
                @change="updateInvoice"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                label="Daerah Antar"
                type="text"
                dense
                small-chips
                hide-details
                v-model="formData.daerah_antar"
                @change="updateInvoice"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="invoice-item">
            <v-col cols="12" md="2">
              <v-text-field
                label="No TTPB (KS)"
                outlined
                dense
                small-chips
                hide-details
                :loading="loading.invoiceDetil"
                v-model="invoiceDetilFormData.ttpb"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Antar Ke"
                outlined
                dense
                small-chips
                hide-details
                :loading="loading.invoiceDetil"
                v-model="invoiceDetilFormData.diantar_ke"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="5">
              <v-text-field
                label="Keterangan"
                outlined
                dense
                small-chips
                hide-details
                :loading="loading.invoiceDetil"
                v-model="invoiceDetilFormData.keterangan"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="1">
              <v-btn color="primary" small @click="addInvoiceDetil">
                Simpan
              </v-btn>
            </v-col>

            <v-col
              cols="12"
              md="12"
              lg="12"
              class="overflow-auto"
              style="height: 250px"
            >
              <v-simple-table height="250px" fixed-header dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">KS</th>
                      <th class="text-left">KC / NoCont</th>
                      <th class="text-left">KodeTTB / NoTTB</th>
                      <th class="text-left">Kondisi Pengiriman</th>
                      <th class="text-left">Pengirim</th>
                      <th class="text-left">Penerima</th>
                      <th class="text-left">Koli</th>
                      <th class="text-left">Diantar Ke</th>
                      <th class="text-left">Keterangan</th>
                      <th class="text-left">Kubikasi</th>
                      <th class="text-left">Tonase</th>
                      <th class="text-left">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in invoiceDetil" :key="item.id">
                      <td>{{ item.ks }}</td>
                      <td>{{ item.kc }} / {{ item.nomor_container }}</td>
                      <td>{{ item.ttb.kodettb }} / {{ item.ttb.nottb }}</td>
                      <td>{{ item.ttb.kondisi_detil.kondisi }}</td>
                      <td>
                        <span v-if="item.ttb.pengirim_detil">{{
                          item.ttb.pengirim_detil.nama_lengkap
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="item.ttb.penerima_detil">{{
                          item.ttb.penerima_detil.nama_lengkap
                        }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>{{ item.container_detil.koli_in }}</td>
                      <td>{{ item.diantar_ke }}</td>
                      <td>{{ item.keterangan }}</td>
                      <td>{{ getKubikasi(item.ttb.ttb_rinci) }}</td>
                      <td>{{ getTonase(item.ttb.ttb_rinci) }}</td>
                      <td>
                        <v-icon @click="deleteItem(item.ttb.kodettb)">
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" lg="3" style="height: 250px">
              <v-btn
                color="primary"
                elevation="2"
                class="w-100 mt-2"
                @click="printInvoice"
                :loading="state.loadingPrint"
                >Print Nota</v-btn
              >
            </v-col>

            <v-col cols="12" md="9" lg="9">
              <v-row>
                <v-col cols="12" md="4" lg="4" class="py-0">
                  <v-text-field
                    label="Total Koli"
                    disabled
                    outlined
                    dense
                    small-chips
                    hide-details
                    v-model="total_koli"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="4" class="py-0">
                  <v-text-field
                    label="Total Kubikasi"
                    disabled
                    outlined
                    dense
                    small-chips
                    hide-details
                    v-model="total_kubikasi"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="4" class="py-0">
                  <v-text-field
                    label="Total Tonase"
                    disabled
                    outlined
                    dense
                    small-chips
                    hide-details
                    v-model="total_tonase"
                  ></v-text-field>
                </v-col>
              </v-row>

              <table>
                <tbody>
                  <tr>
                    <td>
                      <h4>Biaya Akhir</h4>
                    </td>
                    <td></td>
                    <td>=</td>
                    <td>
                      <v-text-field
                        type="text"
                        dense
                        small-chips
                        hide-details
                        v-model="total"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" style="text-align: right"></td>
                    <td></td>
                    <td>
                      <v-text-field
                        dense
                        small-chips
                        hide-details
                        type="text"
                        disabled
                        v-model="total_semua"
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </table>

              <v-text-field
                label="Terbilang"
                outlined
                dense
                small-chips
                hide-details
                class="mt-2"
                disabled
                v-model="formData.terbilang"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <main
      class="report"
      v-if="!state.noData && !state.loading && data.nomor_nota"
      id="section-print"
    >
      <div class="header">
        <div class="tanggal">
          {{ tgl_nota_print }}
        </div>
        <div class="nomor-nota">
          <h6>{{ formData.nomor_nota }}</h6>
          <i>Telah Dibayarkan Kepada:</i>
          <p class="mt-3 mb-3">{{ formData.nama_penagih }}</p>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th width="45%" class="text-left"></th>
            <th class="text-center">Jumlah</th>
            <!-- <th class="text-center">Satuan</th> -->
            <!-- <th class="text-right">Upah Buruh</th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3"></td>
            <td class="text-right" style="border-top: 1px solid black">
              Rp{{ total_semua }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="footer">
        <div class="keterangan">
          <p><b>Keterangan Lunas:</b></p>
        </div>
        <div class="rincian">
          <div class="total-upah">
            <h6>Total Biaya Truk</h6>
            <h6>Rp{{ total_semua }}</h6>
          </div>
        </div>
        <div class="ttd">
          <div class="tgl-ttd">{{ tgl_nota_print }}</div>
          <div class="menerima">Yg menerima,</div>
        </div>
      </div>
    </main>

    <!-- Pop Up fetch invoice data -->
    <FindNomorNota :openModal="!haveNomorNota" @close-modal="setInvoiceData" />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="formatForm"
    >
      New
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {
    FindNomorNota: () => import("@/components/BiayaBongkar/BiayaTrukModal.vue")
  },
  data() {
    return {
      haveNomorNota: false,
      state: {
        loading: false,
        no_data: true,
        loadingPrint: false,
        noData: true
      },
      loading: {
        nomor_nota: false,
        customers: false,
        invoiceDetil: false
      },
      findForm: {
        nomor_nota: "",
        nama_kapal: ""
      },
      items: {
        kode_nota: [
          {
            text: "P",
            value: "P"
          },
          {
            text: "L",
            value: "L"
          },
          {
            text: "ND",
            value: "ND"
          }
        ],
        customers: [],
        units: [
          {
            text: "M3",
            value: "M3"
          },
          {
            text: "Ton",
            value: "Ton"
          },
          {
            text: "Unit",
            value: "Unit"
          },
          {
            text: "Container",
            value: "Container"
          }
        ],
        employees: []
      },
      formData: {},
      invoiceDetil: [],
      invoiceDetilFormData: {
        ttpb: "",
        diantar_ke: "",
        keterangan: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    total: {
      get() {
        return this.formatCurrency(this.formData.total);
      },
      set(value) {
        return (this.formData.total = this.convertToAngka(value));
      }
    },
    total_semua() {
      return this.formatCurrency(this.formData.total);
    },
    total_koli() {
      let total = 0;

      if (this.invoiceDetil.length == 0) {
        return total;
      }

      this.invoiceDetil.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(data => {
          total += parseInt(data.koli);
        });
      });

      return total;
    },
    total_kubikasi() {
      let total = 0;

      if (this.invoiceDetil.length == 0) {
        return total;
      }

      this.invoiceDetil.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(data => {
          total += data.m3;
        });
      });

      return total.toFixed(2);
    },
    total_tonase() {
      let total = 0;

      if (this.invoiceDetil.length == 0) {
        return total;
      }

      this.invoiceDetil.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(data => {
          total += data.ton;
        });
      });

      return total.toFixed(2);
    },
    tgl_nota_print() {
      let date = new Date(this.formData.tgl_nota);
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    }
  },
  watch: {
    async total_semua(val) {
      this.formData.terbilang = this.pembilang(this.convertToAngka(val));

      if (!this.formData.nomor_nota) return;

      await axios
        .put(`kas/biaya-truk`, {
          no_transaksi: this.formData.nomor_nota,
          subtotal: this.convertToAngka(val)
        })
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    "formData.terbilang"(val) {
      if (!this.formData) {
        this.updateInvoice();
      }
    },
    "invoiceDetilFormData.ttpb"(val) {
      if (val) {
        this.invoiceDetilFormData.ttpb = val.toUpperCase();
      }
    }
  },
  methods: {
    async printInvoice() {
      this.state.loadingPrint = true;

      await axios
        .get(`biaya-truk/nota-by-nomor?nomor_nota=${this.formData.nomor_nota}`)
        .then(res => {
          if (!res.data.nomor_nota) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loadingPrint = false;

          setTimeout(() => {
            window.print();
          }, 500);
        })
        .catch(err => {
          this.state.loadingPrint = false;

          alert(err.response.data.message);
        });
    },
    setInvoiceData(val) {
      this.haveNomorNota = true;

      this.formData = val;
      this.fetchInvoiceDetil();
    },
    fetchInvoice() {
      this.loading.nomor_nota = true;

      axios
        .post(`biaya-truk/fetch-invoice`, this.findForm)
        .then(res => {
          this.formData = res.data.invoice;
          this.fetchInvoiceDetil();

          this.loading.nomor_nota = false;
        })
        .catch(err => {
          this.loading.nomor_nota = false;

          alert(err.response.data.message);
        });
    },
    fetchInvoiceDetil() {
      this.loading.invoiceDetil = true;

      axios
        .get(`biaya-truk/invoice-detil?nomor_nota=${this.formData.nomor_nota}`)
        .then(res => {
          this.invoiceDetil = res.data;

          this.loading.invoiceDetil = false;
        })
        .catch(err => {
          this.loading.invoiceDetil = false;

          alert(err.response.data.message);
        });
    },
    updateInvoice() {
      axios
        .put(`biaya-truk/update/${this.formData.nomor_nota}`, this.formData)
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    addInvoiceDetil() {
      this.loading.invoiceDetil = true;

      let formData = {
        kv: this.formData.nomor_nota,
        nomor_nota: this.formData.nomor_nota,
        ttpb: this.invoiceDetilFormData.ttpb,
        diantar_ke: this.invoiceDetilFormData.diantar_ke,
        keterangan: this.invoiceDetilFormData.keterangan
      };

      axios
        .post(`biaya-truk/add-item`, formData)
        .then(res => {
          this.invoiceDetilFormData.ttpb = "";
          this.invoiceDetilFormData.diantar_ke = "";
          this.invoiceDetilFormData.keterangan = "";

          this.loading.invoiceDetil = false;

          // this.focusInputTTB();
          this.fetchInvoiceDetil();
        })
        .catch(err => {
          this.loading.invoiceDetil = false;

          alert(err.response.data.message);
        });
    },
    deleteItem(id) {
      axios
        .delete(
          `biaya-truk/delete?kodettb=${id}&nomor_nota=${this.formData.nomor_nota}`
        )
        .then(res => {
          this.fetchInvoiceDetil();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchKaryawan() {
      this.loading.karyawan = true;

      await axios
        .get(`karyawan`)
        .then(res => {
          this.items.employees = res.data.map(item => ({
            text: item.nama,
            value: `${item.user_id}`
          }));

          this.loading.employees = false;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    formatForm() {
      this.state = {
        loading: false,
        no_vessel: true,
        loadingPrint: false,
        noData: true
      };

      this.findForm = {
        nomor_nota: "",
        nama_kapal: ""
      };

      this.invoiceDetil = [];

      this.haveNomorNota = false;

      this.formData = {};
    },
    getKoli(data) {
      let total = 0;

      data.forEach(invoice => {
        total += parseInt(invoice.koli);
      });

      return total;
    },
    getKubikasi(data) {
      let total = 0;

      data.forEach(val => {
        total += val.m3;
      });

      return total.toFixed(2);
    },
    getTonase(data) {
      let total = 0;

      data.forEach(val => {
        total += val.ton;
      });

      return total.toFixed(2);
    },
    focusInputTTB() {
      this.$nextTick(() => {
        this.$refs.focusNoTTB.$refs.input.click();
      });
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    },
    pembilang(nilai) {
      const _isNominalValid = nilai => {
        const regex = new RegExp(/^\d+$/);
        return !regex.test(nilai);
      };
      const _nominalWording = nilai => {
        const UNIQUE_TWELVE = 12;
        const UNIQUE_TWENTY = 20;
        const UNIQUE_TWO_HUNDRED = 200;
        const UNIQUE_TWO_THOUSAND = 2000;
        const UNIQUE_NAMING = [
          "",
          "Satu ",
          "Dua ",
          "Tiga ",
          "Empat ",
          "Lima ",
          "Enam ",
          "Tujuh ",
          "Delapan ",
          "Sembilan ",
          "Sepuluh ",
          "Sebelas "
        ];
        const TEN = 10;
        const ONE_HUNDRED = 100;
        const ONE_THOUSAND = 1000;
        const ONE_MILLION = 1000000;
        const ONE_BILLION = 1000000000;
        const ONE_TRILLION = 1000000000000;
        if (nilai < ONE_HUNDRED) {
          if (nilai < UNIQUE_TWELVE) return UNIQUE_NAMING[nilai];
          if (nilai < UNIQUE_TWENTY)
            return _nominalWording(nilai % TEN) + "Belas ";
          return (
            _nominalWording(Math.floor(nilai / TEN)) +
            "Puluh " +
            _nominalWording(nilai % TEN)
          );
        }
        if (nilai < ONE_THOUSAND) {
          if (nilai < UNIQUE_TWO_HUNDRED)
            return "Seratus " + _nominalWording(nilai % ONE_HUNDRED);
          return (
            _nominalWording(Math.floor(nilai / ONE_HUNDRED)) +
            "Ratus " +
            _nominalWording(nilai % ONE_HUNDRED)
          );
        }
        if (nilai < ONE_MILLION) {
          if (nilai < UNIQUE_TWO_THOUSAND)
            return "Seribu " + _nominalWording(nilai % ONE_THOUSAND);
          return (
            _nominalWording(Math.floor(nilai / ONE_THOUSAND)) +
            "Ribu " +
            _nominalWording(nilai % ONE_THOUSAND)
          );
        }
        if (nilai < ONE_BILLION)
          return (
            _nominalWording(Math.floor(nilai / ONE_MILLION)) +
            "Juta " +
            _nominalWording(nilai % ONE_MILLION)
          );
        return (
          _nominalWording(Math.floor(nilai / ONE_BILLION)) +
          "Miliar " +
          _nominalWording(nilai % ONE_BILLION)
        );
      };
      if (_isNominalValid(nilai)) return "Nol Rupiah";

      return _nominalWording(nilai) + "Rupiah";
    }
  },
  created() {
    this.fetchKaryawan();
  }
};
</script>

<style scoped>
@media print {
  #section-print {
    width: 80mm auto;
  }
}

@page {
  size: 80mm auto;
}

#section-print {
  display: none;
  font-size: 14px;
  width: 80mm;
  height: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.header {
  display: flex;
  justify-content: space-between;
}

.nomor-nota h6 {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  border: 1px solid black;
}

.rincian {
  display: flex;
  justify-content: end;
}

.ttd {
  margin-top: 1rem;
  display: flex;
  justify-content: space-around;
}

.total-upah h6 {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
}

.total-upah h6:nth-child(2) {
  border: 1px solid black;
}

.invoice-item {
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}

.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

#section-print.report {
  padding: 2px;
}

.header {
  display: flex;
}

.overflow-auto {
  overflow: auto !important;
}

@media print {
  #section-print {
    display: inline-block;
  }

  #hide {
    display: none;
  }
}
</style>
